<template>
  <div id="app">
    <div class="container">
      <!-- Lista de procedimentos do paciente -->
      <b-card v-if="!loading && !showProcedimentoForm">
        <b-card-body>
          <b-list-group>
            <div class="justify-content-end d-flex mb-2 flex-wrap">
              <b-button variant="primary" @click="createProcedimento">
                Inserir
              </b-button>
            </div>
            <div
              v-if="!hasProcedimentos"
              class="d-flex justify-content-center align-items-center"
            >
              <feather-icon
                icon="FileTextIcon"
                size="48"
                class="text-muted mb-2"
              />
              <p class="text-muted">
                {{ emptyStateMessage }}
              </p>
            </div>
            <div v-else>
              <b-list-group-item
                v-for="procedimento in procedimentos"
                :key="procedimento.id"
                class="d-flex justify-content-between align-items-center"
              >
                <div>
                  <p>
                    <small>
                      <b> Data:</b>
                      {{ formatHyphenToSlash(procedimento.data) }}
                    </small>
                  </p>
                  <p>
                    <small>
                      <b> Profissional:</b>
                      {{ procedimento.profissional.nome }}
                    </small>
                  </p>
                </div>

                <div>
                  <b-button
                    variant="outline-primary"
                    size="sm"
                    class="mr-1"
                    title="Editar Procedimento"
                    @click="editProcedimento(procedimento)"
                  >
                    <feather-icon icon="EditIcon" />
                  </b-button>
                </div>
              </b-list-group-item>
            </div>
          </b-list-group>
        </b-card-body>
      </b-card>

      <!-- Loading spinner -->
      <div v-if="loading" class="text-center py-4">
        <b-spinner variant="primary" label="Carregando..." />
        <p class="mt-2 text-muted">Carregando procedimentos...</p>
      </div>

      <!-- Formulário de odontograma (será mostrado quando showOdontogramaForm = true) -->
      <div v-if="showProcedimentoForm">
        <b-row class="justify-content-end d-flex flex-wrap">
          <b-button
            class="mb-3"
            variant="outline-secondary"
            @click="backToList()"
          >
            <feather-icon icon="ArrowLeftIcon" />
            Voltar para Lista
          </b-button>
        </b-row>
        <ProcedimentoFormEdit
          :procedimento-data="procedimento"
          :grupo="grupo.id"
          :create="create"
          :procedimento-id="procedimentoId"
          @save="saveProcedimento"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  BListGroup,
  BListGroupItem,
  BButton,
  BSpinner,
  BRow,
} from "bootstrap-vue";
import ProcedimentoFormEdit from "./ProcedimentoFormEdit.vue";

const TOAST_CONFIG = {
  title: "Erro",
  variant: "danger",
  solid: true,
};

export default {
  components: {
    BCard,
    BCardBody,
    BListGroup,
    BListGroupItem,
    BButton,
    BSpinner,
    BRow,
    ProcedimentoFormEdit,
  },
  props: {
    procedimentos: {
      type: Array,
      required: true,
    },
    grupo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showProcedimentoForm: false,
      loading: false,
      create: false,
      procedimento: [],
      procedimentoId: null,
    };
  },
  computed: {
    hasProcedimentos() {
      return this.procedimentos && this.procedimentos.length > 0;
    },
    emptyStateMessage() {
      return "Nenhum procedimento encontrado para este paciente.";
    },
  },
  methods: {
    async createProcedimento() {
      this.loading = true;

      try {
        const response = await this.$store.dispatch(
          "atendimentoProfissionalModule/create",
          {
            atendimento: this.$route.params.id,
            grupo: this.grupo.id,
          },
        );

        if (response.error) {
          this.showErrorToast(response.message);
          return;
        }

        this.procedimento = response.data;
        this.showProcedimentoForm = true;
        this.create = true;
      } catch (error) {
        this.showErrorToast("Erro ao criar procedimento");
        console.error("Error creating procedimento:", error);
      } finally {
        this.loading = false;
      }
    },
    saveProcedimento(procedimentos) {
      this.procedimento = [...procedimentos];
    },
    async editProcedimento(procedimento) {
      this.loading = true;

      try {
        const response = await this.$store.dispatch(
          "atendimentoProfissionalModule/getById",
          procedimento.id,
        );

        if (response.error) {
          this.showErrorToast(response.message);
          return;
        }

        this.procedimentoId = procedimento.id;
        this.procedimento = response.data;
        this.showProcedimentoForm = true;
        this.create = false;
      } catch (error) {
        this.showErrorToast("Erro ao carregar procedimento");
        console.error("Error loading procedimento:", error);
      } finally {
        this.loading = false;
      }
    },
    async backToList() {
      this.loading = true;

      try {
        // Sempre recarrega os dados do backend
        await this.$emit("refresh-procedimentos");

        this.showProcedimentoForm = false;
        this.procedimento = [];
        this.procedimentoId = null;
        this.create = false;
      } catch (error) {
        this.showErrorToast("Erro ao atualizar lista");
        console.error("Error refreshing procedimentos:", error);
      } finally {
        this.loading = false;
      }
    },
    showErrorToast(message) {
      this.$bvToast.toast(message, TOAST_CONFIG);
    },
    formatHyphenToSlash(dateString) {
      if (!dateString) return "";

      if (
        typeof dateString !== "string" ||
        !/^\d{2}-\d{2}-\d{4}$/.test(dateString)
      ) {
        console.warn("Data não está no formato DD-MM-YYYY:", dateString);
        return dateString;
      }

      return dateString.replace(/-/g, "/");
    },
  },
};
</script>
